module.exports = __webpack_public_path__ + "img/image-1.3f3b5b10.png";